export default {"src":"/_next/static/media/mail-footer.d1d18b83.svg","height":18,"width":23,"blurWidth":0,"blurHeight":0};